module.exports = __webpack_public_path__ + "static/media/cont512.f56d852.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont512.mp4
// module id = +vHm
// module chunks = 0